import React from 'react'
import Header from '../HEADER/Header'
import { Outlet } from 'react-router-dom'

const ContainerOnlyTopbarWithLogout = () => {
  return (
    <div className='relative'>
      <Header/>
      <div className='pt-[70px]' />
      <Outlet />
    </div>
  )
}

export default ContainerOnlyTopbarWithLogout